import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function FAQs() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);
  // The Q&A content lives in the locale files (faqs.items), one array per
  // language, so a country switch re-renders the whole list in that
  // country's language rather than translating only the page chrome.
  const items = t('faqs.items', { returnObjects: true }) || [];

  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('faqs.title')}
      subtitle={t('faqs.subtitle')}
    >
      <div>
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={item.q} className="info-faq-item">
              <button
                className="info-faq-question"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : i)}
              >
                {item.q}
                <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {isOpen && <p className="info-faq-answer">{item.a}</p>}
            </div>
          );
        })}
      </div>
    </InfoPage>
  );
}
